import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { reducer } from 'src/app/state-management/reducers/dashboard.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CyclopsDashboardEffects } from 'src/app/state-management/effects/dashboard.effects';
import { DashboardContainerComponent } from './components/dashboard-container/dashboard-container.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { VisitorDashboardComponent } from './components/visitor-dashboard/visitor-dashboard.component';
import { IncidentDashboardComponent } from './components/incident-dashboard/incident-dashboard.component';
import { ChartsModule } from 'src/app/common/modules/charts/charts.module';
import { VisitorDashboardTableComponent } from './components/visitor-dashboard-table/visitor-dashboard-table.component';
import { WebcamModule } from 'ngx-webcam';
import { IncidentDashboardTableComponent } from './components/incident-dashboard-table/incident-dashboard-table.component';
import { VisitorDetailComponent } from './components/visitor-detail/visitor-detail.component';
import { DialogPopUpsModule } from 'src/app/common/modules/dialog-pop-ups/dialog-pop-ups.module';
import { QRCodeModule } from 'angularx-qrcode';
import { IncidentDetailComponent } from './components/incident-detail/incident-detail.component';
import { PendingHostApprovalsComponent } from './components/pending-host-approvals/pending-host-approvals.component';
import { FaceTimelineTableComponent } from './components/face-timeline-table/face-timeline-table.component';
import { VisitorTimelineComponent } from './components/visitor-timeline/visitor-timeline.component';
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component';
import { BulkInviteModule } from 'src/app/common/modules/bulk-invite/bulk-invite.module';
import { UserCreatePollComponent } from './components/user-create-poll/user-create-poll.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { UserNoticeBoardModule } from 'src/app/common/modules/user-notice-board/user-notice-board.module';
import { HeaderModule } from 'src/app/common/modules/header/header.module';
import { MobileTableCardModule } from 'src/app/common/modules/mobile-table-card/mobile-table-card.module';
import { SecurityPassModule } from '../security-pass/security-pass.module';
import { AnalyticsModule } from '../analytics/analytics.module';
import { SharedPipesModule } from 'src/app/shared/pipe/shared-pipes.module';
import { IncidentSecurityCallbackComponent } from './components/incident-security-callback/incident-security-callback.component';
import { CalendarViewModule } from '../calendar/calendar.module';
import { environment } from 'src/app/environments/environments';
import { MessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { CricitalIncidentsComponent } from './components/cricital-incidents/cricital-incidents.component';
import { FloatingIconModule } from 'src/app/common/modules/floating-icon/floating-icon.module';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input-v16';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { IncidentsTimelineGraphContainerComponent } from './components/dashboard-container/incidents-timeline-graph-container/incidents-timeline-graph-container.component';
import { StatusCommentsComponent } from './components/dashboard-container/status-comments/status-comments.component';
import { VisitorStatusCommentsComponent } from './components/dashboard-container/visitor-status-comments/visitor-status-comments.component';
import { VisitorTimelineGraphContainerComponent } from './components/dashboard-container/visitor-timeline-graph-container/visitor-timeline-graph-container.component';
// import { ExcelHandlerModule } from 'src/app/common/modules/excel-handler/excel-handler.module';
import { ExcelHandlerComponent } from 'src/app/common/modules/excel-handler/excel-handler.component';
import { ViewContainerComponent } from './components/view-container/view-container.component';
import { JwtService } from 'src/app/services/Encryption/jwt-helper.service';
import { RecentDashboardDetailsSectionComponent } from './components/recent-dashboard-details-section/recent-dashboard-details-section.component';
import { SecurityPatrolModule } from 'src/app/common/modules/security-patrol/security-patrol.module';
import { guardPatrolReducer } from 'src/app/state-management/reducers/guard-patrol.reducer';
import { GuardPatrolEffects } from 'src/app/state-management/effects/guard-patrol.effects';

const component = [
  DashboardComponent,
  DashboardContainerComponent,
  VisitorDashboardComponent,
  IncidentDashboardComponent,
  VisitorDashboardTableComponent,
  IncidentDashboardTableComponent,
  VisitorDetailComponent,
  IncidentDetailComponent,
  PendingHostApprovalsComponent,
  FaceTimelineTableComponent,
  VisitorTimelineComponent,
  UserDashboardComponent,
  UserCreatePollComponent,
  IncidentSecurityCallbackComponent,
  CricitalIncidentsComponent,
  IncidentsTimelineGraphContainerComponent,
  StatusCommentsComponent,
  VisitorTimelineGraphContainerComponent,
  VisitorStatusCommentsComponent,
  ViewContainerComponent,
  RecentDashboardDetailsSectionComponent,
  // ExcelHandlerModule,
];
const module = [
  CommonModule,
  DashboardRoutingModule,
  MaterialModule,
  StoreModule.forFeature('aumyeDashboardState', reducer),
  StoreModule.forFeature('guardPatrolState', guardPatrolReducer),
  EffectsModule.forFeature([CyclopsDashboardEffects, GuardPatrolEffects]),
  ChartsModule,
  WebcamModule,
  DialogPopUpsModule,
  QRCodeModule,
  BulkInviteModule,
  NgxMaterialTimepickerModule,
  UserNoticeBoardModule,
  HeaderModule,
  MobileTableCardModule,
  SecurityPassModule,
  AnalyticsModule,
  SharedPipesModule,
  CalendarViewModule,
  FloatingIconModule,
  NgxMatIntlTelInputComponent,
  PdfViewerModule,
  SecurityPatrolModule,
];

@NgModule({
  declarations: [...component],
  imports: [
    ...module,
    ExcelHandlerComponent,
    MessagingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
  ],
  providers: [DatePipe, JwtService],
})
export class DashboardModule {}
